import { COMMANDS } from "$lib/commands";
import { valueWritable } from "@ceyper-common";

import { derived } from "svelte/store";
import { file as $file, interaction as $interaction } from "$lib/state";
import { notImplemented } from "$lib/commands/common";
import type { Interface as WasmInterface } from "svelte-pixel-editor-wasm";
import type { ToolOptions } from "$lib/wasm/interaction";

const isEditingLayer = derived(
    [$file, $interaction],
    ([file, interaction]) => !!file && !!interaction
);

export type EditFunctionName = Parameters<typeof WasmInterface.prototype.execute_edit_function>[0];

export const current_edit_function = valueWritable(
    null as {
        name: EditFunctionName;
        options: ToolOptions;
    } | null
);

export function execute_function(name: EditFunctionName, undo = false) {
    let prev = current_edit_function.value;

    let options: ToolOptions;
    // if (prev?.name === name) {
    if (undo && prev) {
        options = prev.options;
    } else {
        options = $interaction.value.internal.get_default_edit_function_options(name);
    }

    if (undo) {
        $file.value!.internal.undo_no_events();
    }
    $interaction.value.internal.execute_edit_function(name, options);

    if (!undo) {
        current_edit_function.set({ name, options });
    }
}

export function clear_function_context() {
    current_edit_function.set(null);
}

export function registerEditCommands() {
    const { add, destroy } = COMMANDS.registerActions("all");

    add(
        "editor.tool.clear-selection",
        async () => {
            const int = $interaction.value;
            int.internal.clear_selection();
        },
        isEditingLayer
    );

    add(
        "edit.clear",
        async () => {
            execute_function("clear");
        },
        isEditingLayer
    );

    add(
        "edit.offset",
        (x, y) => {
            execute_function("offset");
        },
        isEditingLayer
    );

    add(
        "edit.copy",
        () => {
            execute_function("copy");
        },
        isEditingLayer
    );

    add(
        "edit.paste",
        () => {
            execute_function("paste");
        },
        isEditingLayer
    );

    add(
        "edit.outline",
        (distance = 1, rounded = true) => {
            return notImplemented();

            // const image = activeImage.value!;
            // const layer = activeLayer.value!;
            //
            // const size = image.layers[layer].size;
            // const data = image.layers[layer].data.slice();
            //
            // const toFill = [];
            //
            // for (let i = 0; i < data.length; i++) {
            //     if (data[i] !== Color.transparent) {
            //         continue;
            //     }
            //
            //     const x = i % size.x;
            //     const y = Math.floor(i / size.x);
            //
            //     if (!int.selection.isInside(Vec2.c(x, y))) {
            //         continue;
            //     }
            //
            //     let fill = false;
            //     checkNeighbours: for (let j = -distance; j <= distance; j++) {
            //         for (let k = -distance; k <= distance; k++) {
            //             if (Math.abs(j) + Math.abs(k) > distance) {
            //                 continue;
            //             }
            //
            //             const nx = x + j;
            //             const ny = y + k;
            //
            //             if (nx >= 0 && nx < size.x && ny >= 0 && ny < size.y) {
            //                 if (data[ny * size.x + nx] !== 0) {
            //                     fill = true;
            //                     break checkNeighbours;
            //                 }
            //             }
            //         }
            //     }
            //
            //     if (fill) {
            //         toFill.push(i);
            //     }
            // }
            //
            // for (let index of toFill) {
            //     data[index] = palette.primary.value;
            // }
            //
            // int.data = data;
            // int.refresh();
            // int.apply();
        },
        isEditingLayer
    );

    return { destroy };
}
